import {useCallback, useEffect, useReducer, useState} from 'react'
import {usePagination} from "./usePagination";
import {getPaginatedProduct, removeProduct} from "../services/product";
import filterReducers from "../reducers/filterReducer";


export function useProductList() {
  const [productList, setProductList] = useState({
    products: [],
    total: 0,
  })
  const {pagination, changePagination} = usePagination({
    page: 1,
    limit: 10,
  })
  const [searchTerm, setSearchTerm] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [filter, filterDispatch] = useReducer(filterReducers, {});
  const [error, setError] = useState(false)
  const searchByTerm = async (value) => {
    setSearchTerm(value)
  }
  const fetch = useCallback(async () => {
    try {
      setIsLoading(true)
      const products = await getPaginatedProduct({
        page: pagination.page,
        ...filter,
      })
      setProductList({
        products: products.data,
        total: products.total,
      })
      setIsLoading(false)
    } catch (err) {
      setError({
        title: 'Something went wrong',
        message: err.message,
      })
    }
  }, [pagination, filter])

  const deleteProduct = async (id) => {
    await removeProduct(id)
    await fetch()
  }

  useEffect(() => {
    fetch()
  }, [fetch])

  return {
    productList,
    pagination,
    changePagination,
    deleteProduct,
    searchByTerm,
    isLoading,
    error,
    filter,
    filterDispatch
  }
}